/**
 * 接口文档
 *  http://api-doc-sl.inshopline.com/#/project/80/feature%2F20210907_v1.0.0/interface/c6faea8f1f57304a4c3c2196a694ad76
 */
export default {
  /** 获取枚举列表 */
  list: '/api/countries/list',
}
